<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="listadoSuperintendentes">
      <template v-slot:[`item.acciones`]="{ item }">
        <v-tooltip
        v-if="mixValidaScopesActions(3)"
        top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="borrarSuperintendente(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>Borrar</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ListadoResponsablesContratoDesktop',
  props: {
    listadoSuperintendentes: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        {
          text: 'Nombre',
          align: 'start',
          sortable: false,
          value: 'nombreCompleto',
        },
        { text: 'Datos de Contacto?', value: 'datosContacto' },
        {
          text: '', align: 'end', width: '150', value: 'acciones',
        },
      ],
    };
  },
  methods: {
    borrarSuperintendente(superintendente) {
      eventBus.$emit('borrar-superintendente-contrato', superintendente);
    },
  },
};
</script>

<style lang="scss">
</style>
